import { Box, Divider, Flex, Link, Text, useDisclosure } from "@chakra-ui/react";
import GitcoinLogo from "../../../assets/gitcoinlogo-white.svg";
import { renderToHTML } from "common/src/markdown";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { ExpandableGrid } from "../../common/ExpandableGrid";
import { dateFromMs } from "../../api/utils";
import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { useEnsName } from "wagmi";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const EthereumAddressToENSName = _ref => {
  let {
    address,
    shouldTruncate = true
  } = _ref;
  const {
    data: ensName
  } = useEnsName({
    address
  });
  const lowerCasedAddress = address.toLowerCase();
  const addressToDisplay = shouldTruncate ? (lowerCasedAddress === null || lowerCasedAddress === void 0 ? void 0 : lowerCasedAddress.slice(0, 6)) + "..." + (lowerCasedAddress === null || lowerCasedAddress === void 0 ? void 0 : lowerCasedAddress.slice(-6)) : lowerCasedAddress;
  return /*#__PURE__*/_jsx("span", {
    className: "font-body",
    children: ensName || addressToDisplay
  });
};
export const ImpactItem = _ref2 => {
  var _impact$data, _impact$data2, _impact$data3, _impact$data4, _impact$data5, _impact$data6, _impact$data7, _impact$data8, _impact$data9, _impact$data10, _impact$data11;
  let {
    impact,
    url
  } = _ref2;
  const {
    isOpen,
    onToggle
  } = useDisclosure();
  const impactImageProps = {
    bg: "green.900",
    borderRadius: "full",
    height: 8,
    width: 8,
    bgImage: GitcoinLogo,
    bgRepeat: "no-repeat",
    bgPosition: "45% 40%",
    bgSize: "50%"
  };
  return /*#__PURE__*/_jsx(Box, {
    mb: 4,
    children: /*#__PURE__*/_jsxs(Box, {
      bg: "gray.50",
      borderRadius: 4,
      p: 5,
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 4,
        children: [/*#__PURE__*/_jsxs(Flex, {
          w: "full",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          children: [/*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsxs(Text, {
              fontWeight: "semibold",
              className: "flex gap-3",
              children: [/*#__PURE__*/_jsx(Box, {
                ...impactImageProps,
                className: "__impact-image"
              }), /*#__PURE__*/_jsx(Link, {
                href: url,
                target: "_blank",
                className: "ml-2 max-w-lg",
                children: (_impact$data = impact.data) !== null && _impact$data !== void 0 && _impact$data.impact && impact.data.impact.split(" ").length > 20 ? `${impact.data.impact.split(" ").slice(0, 20).join(" ")}...` : (_impact$data2 = impact.data) === null || _impact$data2 === void 0 ? void 0 : _impact$data2.impact
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            justify: "flex-end",
            gap: 5,
            children: [/*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsxs("small", {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "hidden md:inline",
                  children: "Completed on: "
                }), (_impact$data3 = impact.data) !== null && _impact$data3 !== void 0 && _impact$data3.completedAt ? dateFromMs(impact.data.completedAt * 1000) : "N/A"]
              })
            }), impact.verified.length > 0 && /*#__PURE__*/_jsxs("div", {
              className: "bg-teal-100 flex gap-2 rounded-full px-2 text-xs items-center font-modern-era-medium text-teal-500",
              children: [/*#__PURE__*/_jsx(ShieldCheckIcon, {
                className: "w-4 h-4"
              }), "Verified"]
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(ChevronDownIcon, {
            className: `cursor-pointer h-5 inline ${isOpen && "rotate-180"} transition-transform`,
            onClick: onToggle
          })
        })]
      }), /*#__PURE__*/_jsx(ExpandableGrid, {
        isOpen: isOpen,
        children: /*#__PURE__*/_jsxs(Box, {
          overflow: "hidden",
          children: [/*#__PURE__*/_jsx(Divider, {
            borderWidth: 1,
            my: 4
          }), /*#__PURE__*/_jsxs(Box, {
            __css: {
              h1: {
                fontSize: "1.5rem",
                fontWeight: "bold",
                margin: "1rem 0"
              },
              h2: {
                fontSize: "1.25rem",
                fontWeight: "bold",
                margin: "1rem 0"
              }
            },
            children: [/*#__PURE__*/_jsx(Text, {
              fontWeight: "bold",
              mb: 2,
              children: "Work:"
            }), /*#__PURE__*/_jsx(Box, {
              dangerouslySetInnerHTML: {
                __html: renderToHTML(((_impact$data4 = impact.data) === null || _impact$data4 === void 0 ? void 0 : _impact$data4.work) || "")
              }
            }), /*#__PURE__*/_jsx(Text, {
              fontWeight: "bold",
              mt: 4,
              mb: 2,
              children: "Impact:"
            }), /*#__PURE__*/_jsx(Box, {
              dangerouslySetInnerHTML: {
                __html: renderToHTML(((_impact$data5 = impact.data) === null || _impact$data5 === void 0 ? void 0 : _impact$data5.impact) || "")
              }
            }), /*#__PURE__*/_jsx(Text, {
              fontWeight: "bold",
              mt: 4,
              mb: 2,
              children: "Proof:"
            }), /*#__PURE__*/_jsx(Link, {
              href: (_impact$data6 = impact.data) === null || _impact$data6 === void 0 ? void 0 : _impact$data6.proof,
              target: "_blank",
              color: "blue.500",
              children: (_impact$data7 = impact.data) === null || _impact$data7 === void 0 ? void 0 : _impact$data7.proof
            }), impact.verified.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Text, {
                fontWeight: "bold",
                mt: 4,
                mb: 2,
                children: "Verifications:"
              }), Array.from(new Set(impact.verified.map(v => v.attester))).map((attester, index) => /*#__PURE__*/_jsxs(Text, {
                children: ["Verified by:", " ", /*#__PURE__*/_jsx(EthereumAddressToENSName, {
                  address: attester
                })]
              }, index))]
            }), /*#__PURE__*/_jsx(Text, {
              fontWeight: "bold",
              mt: 4,
              mb: 2,
              children: "Timeframe:"
            }), /*#__PURE__*/_jsxs(Text, {
              children: [(_impact$data8 = impact.data) !== null && _impact$data8 !== void 0 && _impact$data8.startedAt ? dateFromMs(((_impact$data9 = impact.data) === null || _impact$data9 === void 0 ? void 0 : _impact$data9.startedAt) * 1000) : "N/A", " → ", (_impact$data10 = impact.data) !== null && _impact$data10 !== void 0 && _impact$data10.completedAt ? dateFromMs(((_impact$data11 = impact.data) === null || _impact$data11 === void 0 ? void 0 : _impact$data11.completedAt) * 1000) : "N/A"]
            })]
          })]
        })
      })]
    })
  });
};